/**
 * 草稿自动缓存
 *
 * 通过 ttx.__DRAFT_ENABLED__ 控制开关
 * 每单据一个 localStorage key，值类型为数组 [{time, data}, ...]
 */
(function () {
    var STORAGE_PREFIX = 'ttx_draft_';

    /** 拼接 key */
    function _key(vm) {
        var billno = vm?.getDiworkCode?.() || vm?._get_data?.('serviceCode') || '';
        return STORAGE_PREFIX + billno;
    }

    /** 判断数据是否为空 */
    function _isEmpty(obj) {
        if (!obj || typeof obj !== 'object') return true;
        for (var k in obj) { if (obj.hasOwnProperty(k)) return false; }
        return true;
    }

    /** 读取草稿数组，兼容旧格式 */
    function _loadArray(key) {
        try {
            var raw = localStorage.getItem(key);
            if (!raw) return [];
            var parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) { return []; }
    }

    /** 写入草稿数组 */
    function _saveArray(key, arr) {
        try { localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
    }

    // ========== API ==========

    ttx.draft = {
        /** 手动保存：追加一条草稿（可指定名称） */
        save: function (vm, name) {
            if (!ttx.__DRAFT_ENABLED__) return;
            var data = vm?.getData?.();
            if (!data || _isEmpty(data)) return;
            var key = _key(vm);
            var list = _loadArray(key);
            var item = { key: Date.now(), data: data };
            if (name) item.name = name;
            list.push(item);
            _saveArray(key, list);
        },

        /** 自动保存：追加一条标记为 auto 的草稿，同时移除旧的 auto */
        autoSave: function (vm) {
            if (!ttx.__DRAFT_ENABLED__) return;
            var data = vm?.getData?.();
            if (!data || _isEmpty(data)) return;
            var key = _key(vm);
            var list = _loadArray(key);
            list = list.filter(function (item) { return !item.auto; });
            list.push({ key: Date.now(), data: data, auto: true });
            _saveArray(key, list);
        },

        /** 读取草稿列表 */
        list: function (vm) {
            return _loadArray(_key(vm));
        },

        /** 保存成功后清空该单据全部草稿 */
        clearAll: function (vm) {
            if (!vm) return;
            try { localStorage.removeItem(_key(vm)); } catch (e) {}
        },

        /** 清除自动保存的草稿（仅 auto），保留手动保存的草稿 */
        clearAuto: function (vm) {
            if (!vm) return;
            try {
                var key = _key(vm);
                var list = _loadArray(key);
                list = list.filter(function (item) { return !item.auto; });
                if (list.length) _saveArray(key, list);
                else localStorage.removeItem(key);
            } catch (e) {}
        },

        /** 新增时检测草稿，有则弹窗恢复（取最新一条） */
        checkOnAdd: function (vm) {
            if (!ttx.__DRAFT_ENABLED__) return;
            var list = _loadArray(_key(vm));
            if (!list.length) return;
            var latest = list.reduce(function (a, b) { return a.key > b.key ? a : b; });
            ttx.modal.confirm({
                title: '草稿恢复',
                content: '检测到' + list.length + '条草稿，是否恢复最新？',
                onConfirm: function () {
                    vm._set_data?.('value', latest.data, true);
                    var listeners = vm._get_data?.('listeners') || [];
                    listeners.forEach(function (l) {
                        vm.notifyListener?.(l, 'setListenerState', { value: latest.data });
                    });
                    vm.execute?.('dataRefresh');
                },
            });
        },

        /** 启动自动保存（2s 防抖） */
        enableAutoSave: function (vm) {
            if (!ttx.__DRAFT_ENABLED__ || !vm) return;
            if (vm._draftTimer) clearTimeout(vm._draftTimer);
            var self = this;
            var _save = function () {
                if (vm._draftTimer) clearTimeout(vm._draftTimer);
                // 进入防抖等待 + 保存过程，通知头部展示"草稿保存中"
                vm.execute?.('draftSaving', { saving: true, vm: vm });
                vm._draftTimer = setTimeout(function () {
                    self.autoSave(vm);
                    vm.execute?.('draftSaving', { saving: false, vm: vm });
                }, 2000);
            };
            vm.on?.('afterValueChange', _save);
            vm._draftSaveHandler = _save;
        },

        /** 停止自动保存 */
        disableAutoSave: function (vm) {
            if (!vm) return;
            if (vm._draftTimer) { clearTimeout(vm._draftTimer); vm._draftTimer = null; }
            if (vm._draftSaveHandler) { vm.un?.('afterValueChange', vm._draftSaveHandler); vm._draftSaveHandler = null; }
            // 关闭自动保存时同步隐藏"草稿保存中"指示
            vm.execute?.('draftSaving', { saving: false, vm: vm });
        },
    };
})();
